export default {
  direction: (state) => state.direction,
  start: (state) => state.start,
  end: (state) => state.end,
};
